function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("g", {
  "data-name": "Group 4085",
  fill: "none",
  stroke: "#1739e6",
  strokeLinecap: "round",
  strokeWidth: 2
}, React.createElement("path", {
  "data-name": "Line 1",
  d: "M21 1H1"
}), React.createElement("path", {
  "data-name": "Path 231",
  d: "M21 7H1"
}));

var SvgHamburger = function SvgHamburger(props) {
  return React.createElement("svg", _extends({
    width: 22,
    height: 8
  }, props), _ref);
};

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMiIgaGVpZ2h0PSI4IiB2aWV3Qm94PSIwIDAgMjIgOCI+CiAgPGcgaWQ9Ikdyb3VwXzQwODUiIGRhdGEtbmFtZT0iR3JvdXAgNDA4NSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTMzMi4zNjcgLTI4KSI+CiAgICA8bGluZSBpZD0iTGluZV8xIiBkYXRhLW5hbWU9IkxpbmUgMSIgeDE9IjIwIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgzMzMuMzY3IDI5KSIgZmlsbD0ibm9uZSIgc3Ryb2tlPSIjMTczOWU2IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS13aWR0aD0iMiIvPgogICAgPHBhdGggaWQ9IlBhdGhfMjMxIiBkYXRhLW5hbWU9IlBhdGggMjMxIiBkPSJNMjAsMEgwIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgzMzMuMzY3IDM1KSIgZmlsbD0ibm9uZSIgc3Ryb2tlPSIjMTczOWU2IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS13aWR0aD0iMiIvPgogIDwvZz4KPC9zdmc+Cg==";
export { SvgHamburger as ReactComponent };